import styled from 'styled-components';
import { Link } from 'react-router';

export const LinkStyled = styled(Link)`
  text-decoration: underline;
  color: #5798fd;
`;
